import { __makeTemplateObject, __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Box, themeGet, Dialog } from '@primer/react';
import styled from 'styled-components';
import { addAriaPropertiesOnBackgroundEls } from '../../utils/functions.js';
import ModalFooter from './Footer.js';

var Wrapper = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  color: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  color: ", ";\n"])), themeGet("colors.text.default"));
var Header = styled.h4(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: transparent;\n  border: none;\n  display: flex;\n  font-size: 14px;\n  padding: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  font-weight: 600;\n"], ["\n  background: transparent;\n  border: none;\n  display: flex;\n  font-size: 14px;\n  padding: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  font-weight: 600;\n"])));
var ModalHeader = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: calc(100% - 28px);\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: calc(100% - 28px);\n"])));
var Content = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  @media only screen and (max-width: 1024px) {\n    overflow: auto;\n  }\n"], ["\n  @media only screen and (max-width: 1024px) {\n    overflow: auto;\n  }\n"])));
var SubTitle = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-weight: 400;\n  margin-top: 14px;\n"], ["\n  font-weight: 400;\n  margin-top: 14px;\n"])));
var LTModal = function LTModal(_a) {
  var _b = _a.ariaLabel,
    ariaLabel = _b === void 0 ? null : _b,
    children = _a.children,
    customHeaderComponent = _a.customHeaderComponent,
    _c = _a.modalContainer,
    modalContainer = _c === void 0 ? null : _c,
    onClose = _a.onClose,
    title = _a.title,
    subTitle = _a.subTitle,
    renderFooter = _a.renderFooter,
    initialRef = _a.initialRef,
    _d = _a.isOpen,
    isOpen = _d === void 0 ? true : _d,
    focusRef = _a.focusRef,
    extraStyle = _a.extraStyle,
    leadingIcon = _a.leadingIcon,
    minHeight = _a.minHeight,
    maxHeight = _a.maxHeight,
    minWidth = _a.minWidth,
    _e = _a.noPortal,
    noPortal = _e === void 0 ? false : _e,
    rest = __rest(_a, ["ariaLabel", "children", "customHeaderComponent", "modalContainer", "onClose", "title", "subTitle", "renderFooter", "initialRef", "isOpen", "focusRef", "extraStyle", "leadingIcon", "minHeight", "maxHeight", "minWidth", "noPortal"]);
  var extraStyleForSmallScreens = {
    width: "480px",
    borderRadius: "12px",
    height: "auto"
  };
  var styles = __assign(__assign({
    "> button": {
      color: "#666666",
      display: "flex",
      "&:hover": {
        color: "#101010"
      },
      "&:focus-visible": {
        outline: "2px solid",
        outlineColor: "focus.outlineColor"
      }
    },
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    cursor: "default",
    display: "flex",
    flexDirection: "column",
    zIndex: "9999",
    margin: 0
  }, extraStyle), {
    "@media screen and (max-width: 750px)": __assign({}, extraStyleForSmallScreens),
    "@media screen and (max-width: 512px)": __assign(__assign({}, extraStyleForSmallScreens), {
      width: "80%"
    })
  });
  if (minHeight) {
    styles.minHeight = "".concat(minHeight, "px");
  }
  if (maxHeight) {
    styles.maxHeight = "".concat(maxHeight, "px");
  }
  if (minWidth) {
    styles.minWidth = "".concat(minWidth, "px");
  }
  useEffect(function () {
    if (noPortal) return;
    if (isOpen) {
      addAriaPropertiesOnBackgroundEls(false, modalContainer);
    } else {
      addAriaPropertiesOnBackgroundEls(true, modalContainer);
    }
    return function () {
      if (noPortal) return;
      addAriaPropertiesOnBackgroundEls(true, modalContainer);
    };
  }, [isOpen, noPortal]);
  var modalContent = /*#__PURE__*/React.createElement(Dialog, __assign({
    "aria-label": ariaLabel || title,
    "aria-modal": true,
    onDismiss: function onDismiss() {
      onClose();
      if (!noPortal) {
        addAriaPropertiesOnBackgroundEls(true, modalContainer);
      }
    },
    isOpen: isOpen,
    initialFocusRef: initialRef,
    returnFocusRef: focusRef,
    sx: styles
  }, rest), (!!title || !!subTitle || !!customHeaderComponent) && /*#__PURE__*/React.createElement(Dialog.Header, {
    sx: {
      background: "transparent",
      span: {
        fontFamily: "inherit",
        fontSize: "14px"
      }
    }
  }, /*#__PURE__*/React.createElement(Wrapper, null, !!leadingIcon && leadingIcon, /*#__PURE__*/React.createElement(ModalHeader, {
    style: {
      justifyContent: title ? "space-between" : "end"
    }
  }, title && /*#__PURE__*/React.createElement(Header, null, title), customHeaderComponent), subTitle && /*#__PURE__*/React.createElement(SubTitle, null, subTitle))), /*#__PURE__*/React.createElement(Content, null, children), renderFooter);
  return /*#__PURE__*/React.createElement(React.Fragment, null, noPortal ? modalContent : /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
    className: "lt-modal-wrapper"
  }, modalContent), modalContainer || document.body));
};
LTModal.defaultProps = {
  onClose: function onClose() {},
  title: "",
  subTitle: "",
  renderFooter: null,
  initialRef: null,
  focusRef: null,
  extraStyle: {}
};
LTModal.ModalFooter = ModalFooter;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

export { LTModal as default };
